import { Skeleton, Spin } from 'antd';
import { SModal } from 'components/Account/style';
import AntButton from 'components/Common/AntButton';
import fa from 'locales/fa.json';
import React, { useState } from 'react';
import request from 'services/request';
import { MyTransactionsUrl } from 'services/routes';
import { faNumber } from 'utils/common.util';

const Transaction: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);

  const handleClick = async (): Promise<boolean> => {
    setLoading(true);
    const res: any = await request.get(MyTransactionsUrl()); // eslint-disable-line
    setLoading(false);
    if (res.ok) {
      setShowModal(true);
      setList([...list, ...res.data.data]);
      return true;
    }
    return null;
  };

  const handleLoadMore = async (): Promise<void> => {
    setPageLoading(true);
    const res: any = await request.get(MyTransactionsUrl(page + 1)); // eslint-disable-line
    setPageLoading(false);
    res.ok && setPage(page + 1);
    res.ok && setList([...list, ...res.data.data]);
  };

  return (
    <div className="mb-3">
      <div onClick={handleClick} className="cursor-pointer text-[14px] hover:text-blue-0">
        {fa.account.myTransactions} <Spin spinning={loading} />
      </div>
      <SModal
        centered
        title={null}
        footer={null}
        width={900}
        destroyOnClose
        visible={showModal}
        onCancel={(): void => (setShowModal(false), setList([]), setPage(1))}
      >
        <div className="flex flex-col w-full self-start">
          <div className="self-center font-bold text-[18px]">
            {fa.account.transactionList}
          </div>
          <div className="p-[16px] text-[16px]]">
            {list?.map((item, index) => (
              <div key={item.trackingCode} className="mb-4">
                <div className="mb-[4px] w-fit">
                  {faNumber(index + 1)}.{item.description} {item.title} (
                  {!item.price ? fa.global.free : faNumber(item.price.toLocaleString())}{' '}
                  {!!item.price && fa.global.simpleTooman})
                </div>
                <div
                  className={`mr-6 text-[12px] ${
                    !item.success ? 'text-red-0' : 'text-green-5'
                  }`}
                >
                  {fa.account.transactionCode}: {item.trackingCode}
                </div>
              </div>
            ))}
          </div>
          {list.length === 40 * page && (
            <div className="w-full px-[30px] text-center my-[30px]">
              {pageLoading ? (
                <Skeleton active />
              ) : (
                <AntButton width="200px" onClick={handleLoadMore}>
                  {fa.course.loadMore}
                </AntButton>
              )}
            </div>
          )}
        </div>
      </SModal>
    </div>
  );
};

export default Transaction;
